

(function ($) {

    $(document).ready(function () {

        $('.sidebar-nav-toggle').on('click', function () {
            toggleMobileMenu();
        });

    });

    toggleMobileMenu = function () {
        var $nav = $('.sidebar-nav'),
            $ul = $nav.find('>ul'),
            $toggle = $nav.find('.sidebar-nav-toggle'),
            ulHeight,
            toggleHeight;

        ulHeight = $ul.outerHeight(true);
        toggleHeight = $toggle.innerHeight();

        if ($nav.hasClass('show')) {
            $nav.height(toggleHeight -2); // the -2px is a quick fix for Chrome to avoid part of the background appearing after the menu has been closed
        } else {
            $nav.height(ulHeight + toggleHeight);
        }
        $nav.toggleClass('show');
    }

})(jQuery);